import { environment as e } from './environment.dev'

export const environment = e;